module.exports = __webpack_public_path__ + "img/hr-level1_idle_mask.b933301c.png";